// telCheck 手机/固话校验
// type 为需要校验的类型 0||空为全部 1为手机 2为固话
// 返回值 0为空 1为正确 2为错误
function telCheck(text,type) {
    let mphonereg = /^1\d{10}$/
    let tphonereg = /(^400[0-9]{7})|(^400(-\d{2,4}){2}$)|(^400(\d{1})(-\d{2,4}){2}$)|(^800[0-9]{7})|(^800[0-9]{7})|(^800(-\d{3,4}){2}$)|(^[0]([0-9]{2,3}-|[0-9]{2,3})[0-9]{7,8}$)/
    if(!text || text.length == 0) {
        return 0;
    }
    if(!type) {
        if(!mphonereg.test(text) && !tphonereg.test(text)) {
            return 2;
        }
        return 1;
    } else if(type == 1) {
        if(!mphonereg.test(text)) {
            return 2;
        }
        return 1;
    } else if(type == 2) {
        if(!tphonereg.test(text)) {
            return 2;
        }
        return 1;
    }
}
export {
    telCheck
}


// WEBPACK FOOTER //
// ./src/util/telCheck.js